import { BeautyService } from './types';

export const makeupBeautyServices: BeautyService[] = [
  {
    title: "GLAM & GO",
    description:
      "Discover the 3 iconic Christian Louboutin products to enhance your look.",
    imagePath: "/looks-gallery/beauty-services/1.avif", 
    duration: 5,
  },
  {
    title: "THE GLAMOUR TOUCH",
    description:
      "A personalized moment for perfect lips, a sublimated complexion or an intensified look.",
    imagePath: "/looks-gallery/beauty-services/2.avif",
    duration: 15,
  },
  {
    title: "THE SIGNATURES LOOKS",
    description:
      "Opt for one of the House's iconic looks and learn how to do it thanks to personalized advices and techniques.",
    imagePath: "/looks-gallery/beauty-services/3.avif",
    duration: 30,
  },
  {
    title: "A MADE TO MEASURE MAKEUP",
    description:
      "A special occasion? Take advantage of a tailor-made service and have your makeup done by an expert from the House.",
    imagePath: "/looks-gallery/beauty-services/4.avif",
    duration: 60,
  },
];